(function() {
  'use strict';

  var LARGE_SELECTION_KEY = 'artmere_large_originals_selection_v1';
  var EXISTING_PDP_BRIDGE_KEY = 'artmere_search_v2_selection_v1';
  var TRANSPORT_MAX_WAIT_MS = 15000;
  var TRANSPORT_SETTLE_MS = 400;

  function bounded(value, limit) {
    return String(value == null ? '' : value).slice(0, limit || 120);
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'artmere-large-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function publish(name, extra, discriminator) {
    if (typeof window.artmerePublishMeasurementEvent !== 'function') return false;
    return window.artmerePublishMeasurementEvent(name, extra || {}, discriminator || eventId());
  }

  function whenMeasurementTransportReady(callback) {
    var fired = false;
    var started = Date.now();

    function run() {
      if (fired) return;
      fired = true;
      callback();
    }

    function attempt() {
      if (fired) return;
      if (typeof window.gtag === 'function' && typeof window.artmerePublishMeasurementEvent === 'function') {
        setTimeout(run, TRANSPORT_SETTLE_MS);
        return;
      }
      if (Date.now() - started >= TRANSPORT_MAX_WAIT_MS) {
        run();
        return;
      }
      setTimeout(attempt, 200);
    }

    if (document.readyState === 'complete') {
      attempt();
    } else {
      window.addEventListener('load', attempt, { once: true });
      setTimeout(attempt, TRANSPORT_MAX_WAIT_MS);
    }
  }

  function itemFromCard(card, fallbackIndex) {
    if (!card) return null;
    var href = card.getAttribute('href') || '';
    var item = {
      item_id: bounded(card.getAttribute('data-item-id'), 80),
      item_variant: bounded(card.getAttribute('data-item-variant-id'), 80),
      item_name: bounded(card.getAttribute('data-item-name'), 160),
      item_list_id: bounded(card.getAttribute('data-item-list-id') || 'large_original_paintings', 80),
      item_list_name: bounded(card.getAttribute('data-item-list-name') || 'Large Original Paintings', 160),
      index: Number(card.getAttribute('data-item-index') || fallbackIndex || 1),
      price: Number(card.getAttribute('data-item-price') || 0),
      currency: bounded(card.getAttribute('data-item-currency') || 'USD', 12),
      item_category: 'Large Original Paintings',
      orientation: bounded(card.getAttribute('data-item-orientation'), 40),
      largest_size: bounded(card.getAttribute('data-item-largest-size'), 80),
      destination_path: bounded(href, 240)
    };
    if (!item.item_id || !item.item_name || !href) return null;
    return item;
  }

  function storeSelection(selection) {
    try {
      var serialized = JSON.stringify(selection);
      sessionStorage.setItem(LARGE_SELECTION_KEY, serialized);
      // The protected global bundle already owns the sitewide PDP arrival bridge.
      // Reuse that verified bridge without modifying or loading Large code sitewide.
      sessionStorage.setItem(EXISTING_PDP_BRIDGE_KEY, serialized);
    } catch (error) {}
  }

  function initLargeOriginalsMeasurement() {
    var root = document.querySelector('[data-large-originals-page]');
    if (!root || window.__artmereLargeOriginalsMeasurementInitialized) return;
    window.__artmereLargeOriginalsMeasurementInitialized = true;
    root.setAttribute('data-large-originals-tracking', 'ready');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-large-product-click]'));
    var items = cards.map(function(card, index) {
      return itemFromCard(card, index + 1);
    }).filter(Boolean);

    if (items.length) {
      whenMeasurementTransportReady(function() {
        publish('view_item_list', {
          surface: 'large_original_paintings',
          item_list_id: 'large_original_paintings',
          item_list_name: 'Large Original Paintings',
          item_count: items.length,
          ecommerce: {
            item_list_id: 'large_original_paintings',
            item_list_name: 'Large Original Paintings',
            items: items
          }
        }, eventId());
      });
    }

    root.addEventListener('click', function(event) {
      var card = event.target && event.target.closest ? event.target.closest('[data-large-product-click]') : null;
      if (card && root.contains(card)) {
        var item = itemFromCard(card, 1);
        if (!item) return;
        var selectedAt = new Date().toISOString();
        storeSelection({ selected_at: selectedAt, item: item });
        publish('select_item', {
          surface: 'large_original_paintings',
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          selected_item_id: item.item_id,
          selected_item_name: item.item_name,
          selected_item_index: item.index,
          orientation: item.orientation,
          largest_size: item.largest_size,
          destination_path: item.destination_path,
          ecommerce: {
            item_list_id: item.item_list_id,
            item_list_name: item.item_list_name,
            items: [item]
          }
        }, selectedAt + ':' + item.item_id);
        return;
      }

      var guideLink = event.target && event.target.closest ? event.target.closest('[data-large-guide-click]') : null;
      if (guideLink && root.contains(guideLink)) {
        publish('large_originals_size_guide_click', {
          surface: 'large_original_paintings',
          source_page: 'large_original_paintings',
          placement: bounded(guideLink.getAttribute('data-placement'), 40),
          destination_path: bounded(guideLink.getAttribute('href'), 240)
        }, eventId());
        return;
      }

      var guidanceLink = event.target && event.target.closest ? event.target.closest('[data-large-guidance-click]') : null;
      if (guidanceLink && root.contains(guidanceLink)) {
        publish('size_guidance_click', {
          surface: 'large_original_paintings',
          source_page: 'large_original_paintings',
          destination_path: 'mailto:hello@theartmere.com'
        }, eventId());
      }
    }, true);
  }

  function publishLargeOriginalsPdpBridge() {
    var selection;
    try {
      selection = JSON.parse(sessionStorage.getItem(LARGE_SELECTION_KEY) || 'null');
    } catch (error) {
      selection = null;
    }
    if (!selection || !selection.item || !selection.selected_at) return;
    var selectedAt = Date.parse(selection.selected_at);
    if (!selectedAt || Date.now() - selectedAt > 30 * 60 * 1000) {
      try { sessionStorage.removeItem(LARGE_SELECTION_KEY); } catch (error) {}
      return;
    }
    var expectedPath;
    try {
      expectedPath = new URL(selection.item.destination_path, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      expectedPath = '';
    }
    if (!expectedPath || window.location.pathname.replace(/\/$/, '') !== expectedPath) return;
    if (publish('artmere_collection_to_pdp', {
      surface: 'product_page',
      source_list_id: selection.item.item_list_id,
      source_list_name: selection.item.item_list_name,
      selected_item_id: selection.item.item_id,
      selected_item_name: selection.item.item_name,
      selected_item_index: selection.item.index,
      selected_at: selection.selected_at,
      ecommerce: { items: [selection.item] }
    }, selection.selected_at + ':' + selection.item.item_id)) {
      try { sessionStorage.removeItem(LARGE_SELECTION_KEY); } catch (error) {}
    }
  }

  function init() {
    initLargeOriginalsMeasurement();
    publishLargeOriginalsPdpBridge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
